<template>
  <div>
    Incoming Tissues: {{caseInfo.incomingRawMaterials}}
    <v-tooltip bottom v-if="incomingRawMaterialAnomalies.length > 0">
      <span slot="activator">
        <v-icon small color="red">fa-exclamation-circle</v-icon>
      </span>

      <div v-for="anomaly in incomingRawMaterialAnomalies">
        <service-as-badge :service-id="anomaly.serviceId" class="unimInlineBlock" v-if="anomaly.serviceId"/>
        {{anomaly.description}}
      </div>
    </v-tooltip>
    <br>

    Histoblocks Created: {{caseInfo.newHistoblockCreated}}
    <v-tooltip bottom v-if="histoblockCreatedAnomalies.length > 0">
      <span slot="activator">
        <v-icon small color="red">fa-exclamation-circle</v-icon>
      </span>

      <div v-for="anomaly in histoblockCreatedAnomalies">
        <service-as-badge :service-id="anomaly.serviceId" class="unimInlineBlock" v-if="anomaly.serviceId"/>
        {{anomaly.description}}
      </div>
    </v-tooltip>
    <br>

    H&E Slides Created: {{caseInfo.heSlidesCreated}}
    <br>


    HC Slides Created: {{caseInfo.hcSlidesCreated}}
    <v-tooltip bottom v-if="HCSlidesCreatedAnomalies.length > 0">
      <span slot="activator">
        <v-icon small color="red">fa-exclamation-circle</v-icon>
      </span>

      <div v-for="anomaly in HCSlidesCreatedAnomalies">
        <service-as-badge :service-id="anomaly.serviceId" class="unimInlineBlock" v-if="anomaly.serviceId"/>
        {{anomaly.description}}
      </div>
    </v-tooltip>
    <br>

    IHC Slides Created: {{caseInfo.ihcSlidesCreated}}
    <v-tooltip bottom v-if="IHCSlidesCreatedAnomalies.length > 0">
      <span slot="activator">
        <v-icon small color="red">fa-exclamation-circle</v-icon>
      </span>

      <div v-for="anomaly in IHCSlidesCreatedAnomalies">
        <service-as-badge :service-id="anomaly.serviceId" class="unimInlineBlock" v-if="anomaly.serviceId"/>
        {{anomaly.description}}
      </div>
    </v-tooltip>
    <br>

    Incoming Slides Scanned {{caseInfo.incomingSlidesScanned}}
    <br>

    <template v-if="isCaseWithoutServices">
      Case without services
      <v-tooltip>
        <span slot="activator">
          <v-icon small color="red">fa-exclamation-circle</v-icon>
        </span>
      </v-tooltip>
      <br>
    </template>
  </div>
</template>

<script>
    import _ from 'lodash'
    import {GetFilteredCaseAnomalies} from '../../services/CaseServiceLogService'
    import ServiceAsBadge from '../Ui/mcc/ServiceAsBadge'

    export default {
        name: 'material-list',
        components: {
            ServiceAsBadge
        },
        props: {
            caseInfo: {
                type: Object,
                required: true
            },
            caseAnomalies: {
                type: Array,
                required: true
            }
        },
        data() {
            return {}
        },
        computed: {
            incomingRawMaterialAnomalies() {
                return _.filter(this.caseAnomalies, it => {
                    return it.type === GetFilteredCaseAnomalies.IncomingRawMaterial
                })
            },
            IHCSlidesCreatedAnomalies() {
                return _.filter(this.caseAnomalies, it => {
                    return it.type === GetFilteredCaseAnomalies.IHCSlidesCreated
                })
            },
            histoblockCreatedAnomalies() {
                return _.filter(this.caseAnomalies, it => {
                    return it.type === GetFilteredCaseAnomalies.HistoblockCreated
                })
            },
            HCSlidesCreatedAnomalies() {
                return _.filter(this.caseAnomalies, it => {
                    return it.type === GetFilteredCaseAnomalies.HCSlidesCreated
                })
            },
            isCaseWithoutServices() {
              return this.caseAnomalies.some((el) => el.type == "CaseWithoutServices")
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/analytics/MaterialList.vue